/**
 * Navbar Module
 * Handles navbar toggle functionality (replaces Bootstrap collapse)
 */

/**
 * Initialize navbar toggle
 */
export const initNavbarToggle = () => {
    const toggleButtons = document.querySelectorAll('.navbar-toggler');

    toggleButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const targetSelector = button.getAttribute('data-target') || button.getAttribute('aria-controls');

            if (!targetSelector) return;

            // Remove # if present
            const cleanSelector = targetSelector.replace('#', '');
            const target = document.getElementById(cleanSelector);

            if (!target) return;

            // Toggle collapse
            const isExpanded = button.getAttribute('aria-expanded') === 'true';

            if (isExpanded) {
                target.classList.remove('show');
                button.setAttribute('aria-expanded', 'false');
            } else {
                target.classList.add('show');
                button.setAttribute('aria-expanded', 'true');
            }
        });
    });

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
        const isToggleButton = e.target.closest('.navbar-toggler');
        const isNavbarCollapse = e.target.closest('.navbar-collapse');

        if (!isToggleButton && !isNavbarCollapse) {
            closeAllNavbarCollapses();
        }
    });

    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeAllNavbarCollapses();
        }
    });
};

/**
 * Close all navbar collapses
 */
const closeAllNavbarCollapses = () => {
    const collapses = document.querySelectorAll('.navbar-collapse.show');
    const toggleButtons = document.querySelectorAll('.navbar-toggler[aria-expanded="true"]');

    collapses.forEach((collapse) => {
        collapse.classList.remove('show');
    });

    toggleButtons.forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
    });
};
